//require('@/service/service_autoatendimento/httpsemtoken')
require('@/service/service_autoatendimento/urljson')

import axios from 'axios'
import { postRenew } from '@/service/service_autoatendimento/token'
import router from '../../router'
// var http 

async function httpsrc(){

  let  url = localStorage.getItem('APIAdaptor')
  let httpnova = axios.create({
    baseURL:url
  })
  httpnova.defaults.headers.modulo = 4
  httpnova.defaults.headers.common['Accept'] = 'application/json'
  return httpnova
} 



// setTimeout(() => {
//   var url = localStorage.getItem('APIAdaptor')
//   http = axios.create({
//     baseURL:url
//   })
//   http.defaults.headers.modulo = 4
//   http.defaults.headers.common['Accept'] = 'application/json'
// }, 100)
async function getToken () {
  try {
    return sessionStorage.getItem('TOKEN')
  } catch (error) {
    router.push('/')
  }
}
async function checkExpireToken (partoken) {
    try {
      partoken.defaults.headers.common['Authorization'] = await getToken()
      let dateExpire = new Date(sessionStorage.getItem('TOKEN_EXPIRA')).getTime()
      let dateNow = new Date(new Date().valueOf()).getTime()
      let expiredTime = Math.round((dateExpire - dateNow) / 1000)
      let expired = expiredTime <= 0
      if (expired) {
        await renewToken(partoken)
      }
      if (isNaN(dateExpire) && router.app._route.name !== 'login') {
        // eslint-disable-next-line
        console.warn('expirou')
        router.push('/')
        window.location.reload()
      }
    } catch (error) {
      router.push('/')
    }
  }
  
async function renewToken (partoken) {
    try {
        var login = {
        grant_type: 'refresh_token',
        username: sessionStorage.getItem('EMAIL'),
        refresh_token: sessionStorage.getItem('REFRESH_TOKEN')
        }
        var response = await postRenew(login)
        var token = 'Bearer ' + response.data.access_token
        var refreshToken = response.data.refresh_token
        var tempo = response.data.expires_in
        var expire = response.data['.expires']
        var created = response.data['.issued']
        if (token !== '') {
        sessionStorage.setItem('TOKEN', token)
        sessionStorage.setItem('REFRESH_TOKEN', refreshToken)
        sessionStorage.setItem('DURACAO', tempo)
        sessionStorage.setItem('TOKEN_EXPIRA', expire)
        sessionStorage.setItem('TOKEN_CRIADO', created)
        partoken.defaults.headers.common['Authorization'] = getToken()
        }
    } catch (error) {
    //   console.log('erro renew token2')
        router.push('/')
    }
}
// CHAMDAS AXIOS
async function get (url, token = true) {
  let ht = await httpsrc() 
  if (token) {
    await checkExpireToken(ht)
  }
  return  ht.get(url);
  //return http.get(url)
}
async function post (url, params) {
  let ht = await httpsrc() 
  await checkExpireToken(ht)
  return  ht.post(url, params)
}
async function put (url, params) {
  let ht = await httpsrc() 
  await checkExpireToken(ht)
  return ht.put(url, params)
}
async function del (url, parms) {
  let ht = await httpsrc() 
  await checkExpireToken(ht)
  return ht.delete(url, parms)
}
async function patch (url, params) {
  let ht = await httpsrc() 
  await checkExpireToken(ht)
  return ht.patch(url, params)
}
// Export
export default {
    get, post, put, del, patch
}